import type { LandingStrings } from './en';

export const es: LandingStrings = {
  header: {
    brandSubtitle: 'Tienda mágica',
    contact: 'Contacto',
    about: 'Acerca',
    language: 'Idioma',
  },
  footer: {
    terms: 'Términos de servicio',
    privacy: 'Política de privacidad',
    copyright: '{year} {holder}. Todos los derechos reservados.',
  },
  home: {
    heroTitle: 'Un acogedor juego 3D de pociones y una tienda mágica.',
    heroDescription:
      'Busca ingredientes entre el desorden mágico, prepara pociones en el caldero y véndelas en tu propia tienda.',
    features: [
      {
        title: 'Diseña tu propio frasco',
        desc: 'Forma, tapón y color de la poción: los frascos bonitos se venden más caros.',
      },
      {
        title: 'Un oficio con sentido',
        desc: 'Cada poción tiene su propia receta, y muchas funcionan de verdad en el juego.',
      },
      {
        title: 'Una historia que seguir',
        desc: 'La abuela se ha ido de vacaciones y te ha dejado su tienda, y una rana llamada Morén exige lo suyo.',
      },
      {
        title: 'Una tienda de verdad tuya',
        desc: 'Solo se vende lo que preparas tú.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Muy pronto',
    tags: { search: 'Ingredientes ocultos', craft: 'Caldero 3D', shop: 'Tienda acogedora' },
  },
  about: {
    title: 'Acerca de Qevryno',
    intro: [
      'Bienvenido a Qevryno: un acogedor juego de preparar pociones donde la magia se siente hecha a mano.',
      'Tu abuela se ha ido de vacaciones y te ha pedido que cuides su misteriosa casa antigua, llena de recetas olvidadas, ingredientes mágicos y un caldero que aún recuerda cómo hervir. Abajo hay una pequeña tienda, y todo el pueblo siente curiosidad por saber quién la cuida ahora.',
      'Prepara pociones, cuida a tu familiar, vende tus creaciones a clientes encantadores y gana monedas para decorar y ampliar tu hogar mágico — a tu ritmo, sin cronómetros.',
    ],
    whatTitle: '¿Qué tipo de juego es?',
    what: [
      'Qevryno es un relajante juego de puzles en 3D que mezcla la búsqueda de objetos ocultos, la alquimia y un pequeño simulador de tienda. Si te gustan los juegos acogedores, los puzles casuales, los juegos de objetos ocultos o los juegos de pociones y tiendas mágicas, este es para ti.',
      'Es un juego individual que funciona sin conexión; internet solo se necesita para las compras y los vídeos opcionales con recompensa. Sin banners ni ventanas emergentes: un vídeo corto de Google AdMob solo se reproduce si pulsas para obtener un bonus. Compras opcionales: gemas y paquetes de ingredientes con contenido visible. Llegará pronto a iOS y Android, en español, inglés, ruso, alemán, francés, neerlandés, italiano, portugués (Brasil), polaco, japonés, coreano, chino tradicional y turco.',
    ],
    doTitle: 'Qué harás',
    doList: [
      'Buscar ingredientes ocultos en mágicos claros 3D del bosque: cada uno es un pequeño diorama.',
      'Preparar recetas mágicas en un caldero táctil: estabilizador, ingrediente principal, hierbas de tiempo y un toque de color.',
      'Diseñar tus propios frascos: forma, tapón y color; los más bonitos se venden más caros.',
      'Llevar tu propia tienda mágica: clientes, reputación, ferias y misiones.',
      'Seguir la historia: la abuela se ha ido de vacaciones y te ha dejado su tienda, y una rana llamada Morén sigue exigiendo lo suyo.',
      'Moler tus hallazgos en el mortero, mezclarlos en el cuenco y añadir purpurina: cada mezcla tiene su textura y su color.',
      'Alimentar a tu familiar y decorar tu tienda.',
    ],
    faqTitle: 'Preguntas frecuentes',
    faq: [
      { q: '¿Qevryno es gratis?', a: 'Sí. El juego es gratuito y se puede jugar sin pagar. Compras opcionales: gemas y paquetes de ingredientes.' },
      { q: '¿Funciona sin conexión?', a: 'Sí. El juego en sí no necesita conexión: prepara pociones en el avión o bajo una manta. Internet solo se usa para las compras y los vídeos opcionales con recompensa.' },
      { q: '¿Tiene anuncios?', a: 'Solo opcionales. No hay banners ni ventanas emergentes entre pantallas. En algunos lugares puedes elegir ver un vídeo corto a cambio de un bonus, como maná extra. Nada en el juego obliga a verlos. Los vídeos los ofrece Google AdMob; consulta la Política de privacidad.' },
      { q: '¿En qué plataformas está?', a: 'iOS y Android, en español, inglés, ruso, alemán, francés, neerlandés, italiano, portugués (Brasil), polaco, japonés, coreano, chino tradicional y turco.' },
      { q: '¿Es estresante?', a: 'Para nada. Es un juego tranquilo: música suave, sin castigos y con un gato con sombrero.' },
    ],
  },
  contact: {
    title: 'Contacto',
    subtitle: '¿Una pregunta sobre Qevryno, un error, una compra o un anuncio? Escríbenos por correo.',
    write: 'Escribir un correo',
    mailSubject: 'Qevryno: soporte',
    tip: 'Cuéntanos qué dispositivo usas y qué ha pasado: así es más fácil ayudarte.',
    info: {
      title: 'Contactos',
      email: 'Correo',
      security: 'Seguridad',
      legalName: 'Desarrolladora',
      address: 'Dirección',
    },
    refunds: {
      title: 'Reembolsos y compras',
      description: 'Todas las compras se hacen a través de Apple App Store o Google Play. Para pedir un reembolso, contacta con la tienda:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/es-es/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=es',
      link: 'Solicitar reembolso',
      note: 'No cobramos pagos directamente y no podemos hacer reembolsos. Si una compra no llegó al juego, abre Ajustes → Restaurar compras o escríbenos.',
    },
  },
  legal: {
    dataController: 'Responsable de datos',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: '',
  },
};
